module.exports = __webpack_public_path__ + "static/media/ic_rec_stop.b45900e8.svg";